import React from 'react';
import {observer} from "mobx-react";
import {PredictionViewModel} from "../../../domain/full-game/models/prediction/prediction-view-model";
import {PREDICTION_WIDGET} from "../predictions-widget.consts";
import {PredictionWidgetCard} from "./prediction-widget.card";
import Carousel from '../../../core/components/carousel/components/carousel';
import styles from "../styles/prediction-widget.module.scss";
import classNames from "classnames";

export const PredictionWidgetCards = observer(({controller, betsImpressionParams, onBookieClick}) => {
  const {state, device, terms} = controller;
  const {isSmallView} = device;
  const {WEB_PREDICTIONS_PREV, WEB_PREDICTIONS_NEXT} = terms;
  const {
    gameId,
    hasOdds,
    competitionId,
    statusGroup,
    currentContext,
    currentLinkModel,
    isContextualMode,
    isContextualUsed
  } = state;

  const {cards, selectedCard, currentIndex} = currentContext

  const onChange = (index) => controller.action(PREDICTION_WIDGET.ACTION_TYPES.marketNavigationClick, {
    index,
    gameId,
    hasOdds,
    competitionId,
    status: statusGroup,
    currentLinkModelName: currentLinkModel.name,
    marketType: selectedCard.type,
    isContextual: isContextualMode,
    contextualUsed: isContextualUsed
  });

  const carouselProps = {
    onChange,
    isSmallView,
    initialIndex: currentIndex,
    nextArrowLabel: WEB_PREDICTIONS_NEXT,
    previousArrowLabel: WEB_PREDICTIONS_PREV,
  }

  const predictionProps = {
    controller,
    betsImpressionParams,
    onBookieClick
  }

  return (
    <div className={classNames(styles.carousel_container)}>
      <Carousel {...carouselProps}>
        {
          cards?.map((card: PredictionViewModel, index: Number) => <PredictionWidgetCard
            card={card} key={card.id} index={index} {...predictionProps}/>)
        }
      </Carousel>
    </div>
  )
});
